// Replaces window.confirm (FA-06, FA-07, FL-29). For destructive actions pass
// `confirmText` (e.g. the group name): the button stays disabled until it is typed.
import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import Modal from './Modal';
import Button from './Button';

export default function ConfirmDialog({
  open = true,
  title,
  message,
  children,
  confirmLabel = 'Potvrdit',
  cancelLabel = 'Zrušit',
  danger = false,
  confirmText,
  loading = false,
  error,
  onConfirm,
  onCancel,
}) {
  const [typed, setTyped] = useState('');
  const needsTyping = Boolean(confirmText);
  const canConfirm = !needsTyping || typed.trim() === String(confirmText).trim();

  return (
    <Modal
      open={open}
      title={title}
      onClose={loading ? undefined : onCancel}
      size="md"
      footer={
        <>
          <Button variant="secondary" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm} disabled={!canConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className="flex gap-3">
        {danger && <AlertTriangle className="h-6 w-6 flex-shrink-0 text-red-600" aria-hidden="true" />}
        <div className="space-y-3 text-sm text-gray-700">
          {message && <p>{message}</p>}
          {children}
          {needsTyping && (
            <label className="block">
              <span className="text-gray-700">
                Pro potvrzení napište <strong>{confirmText}</strong>
              </span>
              <input
                type="text"
                value={typed}
                onChange={(e) => setTyped(e.target.value)}
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500"
                autoComplete="off"
              />
            </label>
          )}
          {error && (
            <p role="alert" className="rounded-md bg-red-50 p-3 text-red-700">
              {error}
            </p>
          )}
        </div>
      </div>
    </Modal>
  );
}
